
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dao/create",
      function () {
        return require("private-next-pages/dao/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dao/create"])
      });
    }
  